import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from "react-redux-toastr";
import {Loader} from "../Common/Loader";
import VideoPlayer from "../Common/VideoPlayer";
import About from "../Common/About";
import { getVideoDetail } from "../../actions/VideoAction";
import { saveVideoClickData } from "../../actions/DashboardAction";
import { getAuthUserDetails, setVideoDetailLocalStorage } from "../../actions/Common";

class PlayFilm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader      : false,
            videoObj:{
                poster  : '',
                source  : '/assets/videos/small.mp4',
                play    : true,
                videoId : 'Video-101',
                clickedVideoDetail:[]
            }
        };
        this.getclickCount = this.getclickCount.bind(this);

    }

    componentWillMount() {
        this.setState({ showLoader: true });
        //Call the get video details
        this.props.getVideoDetail((response)=>{
            this.setState({ showLoader: false });
        });
    }


    /**
     * @name getclickCount
     * @description get total clicked array of video
     * @param array
     * @returns {*}
     */
    getclickCount(clickedArray, videoId){
        let authUserDetail = getAuthUserDetails();
        let videoDetails = {
            videoId: videoId,
            clickedTimeList: clickedArray
        }

        /* Redirect page after save the data */
        if(authUserDetail.loginToken !== undefined ){
            this.setState({ showLoader: true });
            this.props.saveVideoClickData(videoDetails, (response)=>{
                this.setState({ showLoader: false });
                window.location.assign('/after-video');
            });
        }else{
            this.setState({ showLoader: true });
            setVideoDetailLocalStorage(videoDetails);
            this.setState({ showLoader: false });
            window.location.assign('/join-us');
        }
    }

    /**
     * Render dashboard
     * @returns {*}
     */
    render(){
        const videoDetail = this.props.videoDetail;
        if(!this.state.showLoader) {
            return (
                <div>
                <section className="film-page">
                        <div>
                            <VideoPlayer
                            poster={videoDetail.poster}
                            source={videoDetail.source}
                            play={false}
                            videoId={videoDetail.videoId}
                            getclickCount={this.getclickCount}
                            skipTo="dashboard"/>
                        </div>
                </section>
                <About />
                </div>
            );
        } else {
            return <Loader />
        }

    }
}

const mapStateToProps = ({ video }) => {
    //const {videoDetails} = videoDetail;
    let initialValues = {videoDetail:''};

    if(video.videoDetail != undefined) {
        initialValues.videoDetail = video.videoDetail;
    }

    return initialValues;

};

//Connect action to component
export default connect(mapStateToProps, {getVideoDetail, saveVideoClickData})(PlayFilm);



// WEBPACK FOOTER //
// ./components/Film/PlayFilm.js